var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.9954V15.8427C5 16.1769 5.27342 16.4504 5.60767 16.4504H5.89326V13.3877H5.60767C5.27342 13.3877 5 13.6611 5 13.9954Z",
    fill: "#8186F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8372 13.3877H23.5547V16.4504H23.8372C24.1745 16.4504 24.4449 16.1769 24.4449 15.8427V13.9954C24.4449 13.6611 24.1745 13.3877 23.8372 13.3877Z",
    fill: "#8186F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.1086V17.7296C6.5 18.0637 6.7735 18.3372 7.10767 18.3372H7.72142V11.501H7.10767C6.7735 11.501 6.5 11.7744 6.5 12.1086Z",
    fill: "#8186F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3394 11.501H21.7227V18.3372H22.3394C22.6737 18.3372 22.9471 18.0637 22.9471 17.7296V12.1086C22.9471 11.7744 22.6737 11.501 22.3394 11.501Z",
    fill: "#8186F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6027 10H8.93775C8.60358 10 8.33008 10.2735 8.33008 10.6077V19.2275C8.33008 19.5616 8.60358 19.8351 8.93775 19.8351H10.6027C10.94 19.8351 11.2104 19.5616 11.2104 19.2275V10.6077C11.2104 10.2735 10.94 10 10.6027 10Z",
    fill: "#8186F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.507 10H18.842C18.5078 10 18.2344 10.2735 18.2344 10.6077V19.2275C18.2344 19.5616 18.5078 19.8351 18.842 19.8351H20.507C20.8443 19.8351 21.1147 19.5616 21.1147 19.2275V10.6077C21.1147 10.2735 20.8443 10 20.507 10Z",
    fill: "#8186F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6277 13.6157H11.8184V16.4717H17.6277V13.6157Z",
    fill: "#8186F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 28C21.9558 28 28 21.9558 28 14.5C28 7.04416 21.9558 1 14.5 1C7.04416 1 1 7.04416 1 14.5C1 21.9558 7.04416 28 14.5 28Z",
    stroke: "#C9CAEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSports);
export default __webpack_public_path__ + "static/media/iconSports.e2629516.svg";
export { ForwardRef as ReactComponent };